module.exports = __webpack_public_path__ + "img/tablaelementos.26256a95.png";